// Accept only planning routes, never an external URL or the login page itself.
export function planningReturnTo(value) {
  return typeof value === "string" &&
    /^\/(?:planning\/candidatures\/[1-9][0-9]*|[1-9][0-9]*\/[1-9][0-9]*\/(?:planning\/(?:index|getList)|[1-9][0-9]*\/meetings\/getList))(?:\?[^\r\n]*)?$/.test(value)
    ? value
    : "/planning";
}
